export const CALENDLY_BOOK_MEETING_URL =
  'https://calendly.com/contact-ecomguild/30min';

const CALENDLY_CTA_TEXTS = new Set([
  'book a meeting',
  'schedule a call',
  'schedule a meeting',
]);

export const isBookMeetingCta = text =>
  typeof text === 'string' &&
  CALENDLY_CTA_TEXTS.has(text.trim().toLowerCase());

export const openCalendlyPopup = (url = CALENDLY_BOOK_MEETING_URL) => {
  if (typeof window === 'undefined') return;
  const popup = window.open(url, '_blank');
  if (popup) {
    popup.opener = null;
  }
};
